import { Inject, Injectable } from '@angular/core';
import { UTENTI_ENDPOINT, UTENTI_QUERY_SERVICE_INSTANCE } from './utenti.config';
import { IRuolo, IUtente } from './models/utenti.model';
import { ApiSentrynelService } from 'src/app/core/services/api-sentrynel.service';
import { SnackbarService } from 'src/app/core/services/snackbar.service';
import { CrudSentrynelService } from 'src/app/core/services/crud-sentrynel.service';
import { QuerySentrynelService } from 'src/app/core/services/query-sentrynel.service';
import { ApiService } from 'src/app/core/services/api.service';
import { UserDto } from './models/user.model';
const CRUD_ENDPOINT = 'auth';
@Injectable({
  providedIn: 'root'
})
export class UtentiService extends CrudSentrynelService<IUtente> {

  constructor(
    @Inject(UTENTI_QUERY_SERVICE_INSTANCE) public readonly query: QuerySentrynelService<IUtente>,
    @Inject(ApiSentrynelService) protected  readonly apiSentrynel: ApiSentrynelService,
    public readonly apiService:ApiService,
    @Inject(SnackbarService) protected override readonly snackbar: SnackbarService
  ) {
    // Chiamare il costruttore della classe padre con i parametri necessari
    super(UTENTI_ENDPOINT, apiSentrynel, snackbar);
  }
  get() {
    return this.apiSentrynel.get<IUtente>(`${CRUD_ENDPOINT}/users`);
  }
  getRoles(data:any) {
    return this.apiSentrynel.get<IRuolo>(`roles?filter.name=$in:${data}`);
  }
  getRegioniCurrentUser() {
    return this.apiSentrynel.post<any>(`${CRUD_ENDPOINT}/can`, {
      "subject": "punti-campionamento",
      "action": "read"
  });
  }
  createUser(userDto:any){
    return this.apiService.post<any>(`create-user`, userDto);
    
  }
}
